import { render } from "./Contactview.vue?vue&type=template&id=549efd22&scoped=true"
import script from "./Contactview.vue?vue&type=script&lang=js"
export * from "./Contactview.vue?vue&type=script&lang=js"

import "./Contactview.vue?vue&type=style&index=0&id=549efd22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549efd22"]])

export default __exports__